import React, {useEffect} from 'react';
import DetailCard from './ui-components/detail-card';
import {sectionLayoutChildAnimation, sectionLayoutParentAnimation,} from '../utils/animations';
import {useInView} from 'react-intersection-observer';
import {motion, useAnimation} from 'framer-motion';

export default function Section3() {
    const controls = useAnimation();
    const {ref, inView} = useInView({threshold: 0.1, triggerOnce: true});

    useEffect(() => {
        if (inView) {
            controls.start('visible');
        }
        if (!inView) {
            controls.start('hidden');
        }
    }, [controls, inView]);

    const cards = [
        {
            title: 'Your Branded Trail App: Own the Experience',
            image: 'app_1',
            body: [
                'Imagine having a custom-branded mobile app, built on the robust foundation of Adapt, to guide and assess your users on the trails you care about most. With our white-label solution, your organization can publish its very own trail navigation and assessment app, complete with all the features of the individual version and access to our comprehensive trail database.'
            ]
        },
        {
            title: 'Tailored to Your Unique Needs:',
            image: 'scenery_1',
            body: [
                'Beyond the core functionality, we offer the unique opportunity to expand your app to meet your specific organizational goals. At a special nonprofit development rate, you can request additional features like donation buttons, event pages, registration forms, calendars, and more. Let us partner with you to build a truly customized solution.'
            ]
        },
        {
            title: 'Get Started Today:',
            body: [
                'Launch your branded app, including 50 user subscriptions, for an initial investment of $9,999. In subsequent years, you\'ll only pay an affordable $14.99 per user annually.'
            ]
        }
    ];

    return (
        <div className="mb-8 border-b-2 border-gray-300">
            <motion.div
                ref={ref}
                initial="hidden"
                animate={controls}
                variants={sectionLayoutParentAnimation}
                className={`text-center   border-gray-200  `}
            >
                <motion.div
                    variants={sectionLayoutChildAnimation}
                    className="max-w-2xl mx-auto text-center"
                >
                </motion.div>

                <motion.div variants={sectionLayoutParentAnimation} className="mt-5">
                    {cards.map((card, idx) => (
                        <DetailCard
                            cardBackground={false}
                            key={idx}
                            title={card.title}
                            image={card.image}
                            body={card.body}
                            idx={!(idx % 2)}
                        />
                    ))}
                </motion.div>

                <motion.div className='pb-8 font-semibold text-center text-gray-700'>
                    Ready to elevate your organization's engagement? Contact us today to discuss your white-label app and explore the possibilities!
                </motion.div>
            </motion.div>
        </div>
    );
}
